import { useState } from "react";

export default function AuthResetPassword({ state, onChange, onSuccess, onError, authService }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const username = String(state.username || "").trim();
    const code = String(state.code || "").trim();
    const newPassword = String(state.newPassword || "");
    const confirmPassword = String(state.confirmPassword || "");

    if (!username || !code || !newPassword) {
      setError("All fields are required");
      setLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      await authService.confirmPassword(username, code, newPassword);
      setLoading(false);

      if (typeof onSuccess === "function") {
        onSuccess({ action: "login", message: "Password reset successful. Please sign in." });
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err?.message || "An error occurred during password reset";
      setError(errorMessage);

      if (typeof onError === "function") {
        onError(err);
      }
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <form onSubmit={handleSubmit} className="mb-4 rounded px-8 pt-6 pb-8">
        <h2 className="text-center">Verify Reset Code</h2>

        {error && (
          <div className="relative mt-4 mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="username">
            Username / Email
          </label>
          <input
            className="input-text"
            id="username"
            type="text"
            placeholder="Username or Email"
            value={state.username || ""}
            onChange={(e) => onChange("username", e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="code">
            Verification Code
          </label>
          <input
            className="input-text"
            id="code"
            type="text"
            placeholder="Enter the code sent to your email"
            value={state.code || ""}
            onChange={(e) => onChange("code", e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold text-gray-700" htmlFor="newPassword">
            New Password
          </label>
          <input
            className="input-text"
            id="newPassword"
            type="password"
            placeholder="******************"
            value={state.newPassword || ""}
            onChange={(e) => onChange("newPassword", e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="mb-6">
          <label className="mb-2 block text-sm font-bold text-gray-700" htmlFor="confirmPassword">
            Confirm New Password
          </label>
          <input
            className="input-text"
            id="confirmPassword"
            type="password"
            placeholder="******************"
            value={state.confirmPassword || ""}
            onChange={(e) => onChange("confirmPassword", e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="flex items-center justify-between">
          <a className="inline-block align-baseline font-bold text-sm text-proof-blue hover:opacity-80" href="/auth/login">
            Back to Sign in
          </a>
          <button
            className={`bg-proof-blue focus:shadow-outline rounded px-4 py-2 font-bold text-white hover:opacity-80 focus:outline-none ${loading ? "cursor-not-allowed opacity-50" : ""}`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Verifying..." : "Set New Password"}
          </button>
        </div>
      </form>
    </div>
  );
}
